import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Column } from 'devextreme-react/data-grid';

import * as Actions from '../../../redux/keywordActions';
import DataGrid from '../../../../../components/DataGrid';
import * as Selectors from '../../../redux/keywordSelectors';
import useMainProgressContext from '../../../../../components/progress/MainProgress/context/MainProgressContext';
import useDataGridProgressContext from '../../../../../components/progress/DataGridProgress/context/DataGridProgressContext';
import { API_REQUEST_STATE } from '../../../../../core/enums/apiRequestState';
import { ROUTES } from '../../../../../core/router/routes';
import { DataGridCellRender } from '../../../../../components/DataGrid/model/dataGridCellRenderModel';
import { KeywordGetResponse } from '../../../model/keywordModel';
import DataGridLinkTemplate from '../../../../../components/DataGrid/template/DataGridLinkTemplate';

const KeywordDataGrid: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mainProgressContext = useMainProgressContext();
  const dataGridProgressContext = useDataGridProgressContext();
  const keywords = useSelector(Selectors.keywords);
  const keywordsState = useSelector(Selectors.apiKeywordsRequestState);
  const linkRender = (cellData: DataGridCellRender<KeywordGetResponse>, name: string) => {
    return <DataGridLinkTemplate to={ROUTES.KEYWORD.EDIT} value={name} id={cellData.data.id!} />;
  };

  useEffect(() => {
    dataGridProgressContext.show();
  }, []);

  useEffect(() => {
    dispatch(Actions.getAllKeywords({}));
  }, []);

  useEffect(() => {
    mainProgressContext.hide();
  }, [keywords]);

  useEffect(() => {
    if (keywordsState === API_REQUEST_STATE.SUCCEEDED_GET) {
      setTimeout(() => {
        dataGridProgressContext.hide();
      }, 500);
    }
  }, [keywordsState]);

  return (
    <DataGrid rows={keywords}>
      <Column
        dataField="id"
        caption={t('keyword.id')}
        width="10%"
        minWidth="100"
        cellRender={(cellData: DataGridCellRender<KeywordGetResponse>) => {
          return linkRender(cellData, cellData.data.id!);
        }}
      />
      <Column
        dataField="name"
        caption={t('keyword.name')}
        width="90%"
        allowSorting={false}
        minWidth="300"
        cellRender={(cellData: DataGridCellRender<KeywordGetResponse>) => {
          return linkRender(cellData, cellData.data.name);
        }}
      />
    </DataGrid>
  );
};

export default KeywordDataGrid;
